import axios from "./axios";

class UpiAtmService {
  agentRegistration = async () => {
    try {
      const response = await axios.post("/upi_atm/agent/registration", {});

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  ekycStatus = async () => {
    try {
      const response = await axios.post("/upi_atm/agent/ekyc_status", {});

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  ekyc = async (aadhaar, bio_data, latitude, longitude, token) => {
    try {
      const response = await axios.post("/upi_atm/agent/ekyc", {
        aadhaar,
        bio_data,
        latitude,
        longitude,
        token,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  generateQR = async (mobile, amount, latitude, longitude) => {
    try {
      const response = await axios.post("/upi_atm/generate_qr", {
        mobile,
        amount,
        latitude,
        longitude,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  qrStatus = async (order_id) => {
    try {
      const response = await axios.post("/upi_atm/qr_status", { order_id });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };
}
export default new UpiAtmService();
